import React from 'react';
import { RadialBarChart, RadialBar, PolarAngleAxis, ResponsiveContainer } from 'recharts';

import { ReactComponent as TrendDownIcon } from '../../../../assets/icons/gauge-meter-icon.svg';

interface HardwareStatsProperties {
  value: number;
  label?: string;
  units?: string;
  innerRadius?: string;
  outerRadius?: string;
  barSize?: number;
}

/**
 * HardwareStats
 * @param {any} properties - The properties for the component
 * @returns {any} The rendered component
 */
function HardwareStats(properties: HardwareStatsProperties) {
  const { value, label, units, innerRadius, outerRadius, barSize } = properties;

  const data = [{ name: label, value, fill: 'url(#gaugeGradient)' }];
  const needleAngle = (value / 100) * 180 - 90;

  return (
    <div className="gauge-main">
      <div className="gauge-container">
        <div className="gauge-chart">
          <ResponsiveContainer width={400} height={300}>
            <RadialBarChart
              cx="50%"
              cy="100%"
              innerRadius={innerRadius}
              outerRadius={outerRadius}
              barSize={barSize}
              data={data}
              startAngle={180}
              endAngle={0}>
              <defs>
                <linearGradient id="gaugeGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                  <stop offset="0%" stopColor="#22c55e" />
                  <stop offset="50%" stopColor="#eab308" />
                  <stop offset="100%" stopColor="#ef4444" />
                </linearGradient>
              </defs>
              <PolarAngleAxis type="number" domain={[0, 100]} tick={false} axisLine={false} />
              <RadialBar dataKey="value" cornerRadius={0} background={{ fill: '#e5e7eb' }} />
            </RadialBarChart>
          </ResponsiveContainer>

          {/* Needle */}
          <div
            className="needle"
            style={{
              transform: `rotate(${needleAngle}deg)`,
            }}>
            <div className="needle-stick" />
            <div className="needle-base" />
          </div>
        </div>
        <TrendDownIcon className="meter-icon" />

        {/* Center value */}
        <div className="gauge-value">
          <p>
            {value}
            <span className="unit">{units}</span>
          </p>
        </div>
      </div>
    </div>
  );
}

HardwareStats.defaultProps = {
  innerRadius: '60%',
  outerRadius: '100%',
  barSize: 100,
};

export default HardwareStats;
